import { OvlAddDialog } from "../../../_ovlclient/src/global/globals"
import { DialogSYSTOTP } from "./features/dialog"

export const SYSTOTP_Init = () => {
  OvlAddDialog(DialogSYSTOTP, "SYSTOTP")
}
